var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isOpenAddTicketAppDialog,
            width: "1500px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "3vh",
            title: "Thêm phiếu bé ngoan",
            border: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenAddTicketAppDialog = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "createTicketAppRequest",
              attrs: {
                "label-width": "140px",
                model: _vm.createTicketAppRequest,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 100 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Tên phiếu bé ngoan",
                              prop: "nameTicket",
                              "label-width": "170px",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Nhập tên" },
                              model: {
                                value: _vm.createTicketAppRequest.nameTicket,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.createTicketAppRequest,
                                    "nameTicket",
                                    $$v
                                  )
                                },
                                expression: "createTicketAppRequest.nameTicket",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Mô tả",
                            prop: "descriptionTicket",
                            "label-width": "80px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Nhập mô tả" },
                            model: {
                              value:
                                _vm.createTicketAppRequest.descriptionTicket,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.createTicketAppRequest,
                                  "descriptionTicket",
                                  $$v
                                )
                              },
                              expression:
                                "createTicketAppRequest.descriptionTicket",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Màn hình", "label-width": "170px" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "Chọn màn hình" },
                          on: { change: _vm.handleChangeDisplayTicket },
                          model: {
                            value: _vm.displayTicket,
                            callback: function ($$v) {
                              _vm.displayTicket = $$v
                            },
                            expression: "displayTicket",
                          },
                        },
                        _vm._l(_vm.listDisplayTicket, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            staticStyle: { width: "200px" },
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "dataTarget",
                        label: "Chọn trường",
                        "label-width": "170px",
                      },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "170px" },
                              attrs: {
                                placeholder: "Trạng thái kích hoạt",
                                clearable: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.searchHeaderMethod()
                                },
                              },
                              model: {
                                value: _vm.dataSearch.active,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataSearch, "active", $$v)
                                },
                                expression: "dataSearch.active",
                              },
                            },
                            _vm._l(_vm.statusAccountList, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.key, label: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-left": "35px" },
                          attrs: { span: 3 },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "button-left-class",
                              staticStyle: { width: "160px" },
                              attrs: {
                                placeholder: "Trạng thái xóa",
                                clearable: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.searchHeaderMethod()
                                },
                              },
                              model: {
                                value: _vm.dataSearch.deleteStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataSearch, "deleteStatus", $$v)
                                },
                                expression: "dataSearch.deleteStatus",
                              },
                            },
                            _vm._l(_vm.deleteList, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.key, label: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-left": "25px" },
                          attrs: { span: 4 },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              placeholder: "Nhập tên trường",
                              clearable: "",
                            },
                            on: {
                              clear: function ($event) {
                                return _vm.searchHeaderMethod()
                              },
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchHeaderMethod()
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c("el-button", {
                                      attrs: { icon: "el-icon-search" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.searchHeaderMethod()
                                        },
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.dataSearch.nameSchool,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataSearch, "nameSchool", $$v)
                              },
                              expression: "dataSearch.nameSchool",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-row", [
                _c(
                  "div",
                  [
                    _c(
                      "el-transfer",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loadingDataTransfer,
                            expression: "loadingDataTransfer",
                          },
                        ],
                        staticStyle: {
                          "margin-left": "170px",
                          "margin-bottom": "20px",
                          "margin-right": "75px",
                        },
                        attrs: {
                          "element-loading-text": _vm.$tableLoading,
                          titles: [
                            "Tất cả trường chưa chọn",
                            "Trường được chọn",
                          ],
                          "button-texts": ["", ""],
                          data: _vm.dataSource,
                        },
                        model: {
                          value: _vm.dataTarget,
                          callback: function ($$v) {
                            _vm.dataTarget = $$v
                          },
                          expression: "dataTarget",
                        },
                      },
                      [void 0],
                      2
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "170px",
                    "margin-right": "170px",
                  },
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadTicket",
                      staticStyle: { clear: "both" },
                      attrs: {
                        action: "#",
                        "list-type": "picture-card",
                        "auto-upload": false,
                        "file-list": _vm.fileListTicket,
                        "on-change": _vm.handleChangePictureTicket,
                        "on-remove": _vm.handleRemoveTicket,
                        "before-remove": _vm.beforeRemove,
                        "on-preview": _vm.handlePictureCardPreviewTicket,
                        multiple: "",
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "el-icon-plus",
                          staticStyle: {
                            "font-style": "normal",
                            "white-space": "nowrap",
                          },
                          attrs: { slot: "default" },
                          slot: "default",
                        },
                        [_vm._v("Thêm Ảnh")]
                      ),
                    ]
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: { width: "50%", visible: _vm.dialogVisibleTicket },
                      on: {
                        "update:visible": function ($event) {
                          _vm.dialogVisibleTicket = $event
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "100%",
                          src: _vm.dialogImageUrlTicket,
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "tab-infor-button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("createTicketAppRequest")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lưu")]),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v("Đóng")]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }